'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// flatten nested properties to namespaced properties
exports.default = function (properties) {
  var flatten = function flatten(m) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.keys(m).map(function (key) {
      var value = m[key];
      if (value !== undefined && value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Array.isArray(value)) {
        return flatten(value, '' + prefix + key + '/');
      }
      return _defineProperty({}, '' + prefix + key, value);
    }).reduce(function (l, r) {
      return Object.assign({}, l, r);
    }, {});
  };
  return flatten(properties);
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/flatten.js